import { Form,Modal,Input,Switch  } from "antd";
import CampusService from "../../../services/CampusService";
import { useState } from "react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "../../../Auth/userReducer";



export default function CampusForm(props) {
    const { visible, Option, ShowCreateModal,hideCreateModal, updatedTable,CampusTarget } = props;
    const [isChecked,setIsChecked]=useState(true)
    const user=useSelector(selectUser)
    const createCampus= ()=>{
        form.validateFields().then(
            val=>{
                form.resetFields();
                val={
                    ...val,
                    uid: user.id, 
                }   
                console.log("val",val);
                CampusService.createCampus(val).then((res)=>{
                  console.log("Create",res)
                });
                updatedTable(true);
                hideCreateModal(false);
            })
    }

    useEffect(()=>{
        //console.log("CampusTargetInto",CampusTarget)
        form.setFieldsValue(Option? form.resetFields() : CampusTarget)
        setIsChecked(CampusTarget.status)
        //console.log("Option",Option)
    },[CampusTarget,ShowCreateModal,Option])

    const handleOnOK=()=>{
        if(Option){
            createCampus()
        }else{
            updateCampus()
        }
    }


    const updateCampus=()=>{
        console.log(CampusTarget)
        console.log(form.getFieldsValue())
        form.validateFields().then(
            val=>{
                form.resetFields();
                console.log("val",val);   
                CampusService.updateCampus(CampusTarget.id,val).then((res)=>{
                    console.log("update",res)
                });
                updatedTable(true);
                hideCreateModal(false);
            })
    }
    const [form]=Form.useForm();
    return (
        <Modal title={ Option? "Agregar nueva sede" : "Actualización de la sede" }
        open={visible}
        onOk={handleOnOK}
        onCancel={()=>{
            hideCreateModal(false)
            form.validateFields().then(
                val=>{
                    form.resetFields();
                })
        }}
        >
            <Form 
            form={form}
            name='formCampus'
            key={"id"}
            >
                <Form.Item 
                name="name"
                label="Nombre"
                rules={[
                    {
                        required:true,
                        message:"Por Favor, ingrese el nombre de la sede",
                    }
                ]
                }>
                    <Input placeholder='Ej: Universidad Católica Boliviana La Paz'></Input>
                </Form.Item>
                <Form.Item 
                name='location'
                label="Localización"
                rules={[
                    {
                        required:true,
                        message:"Por Favor ingrese",
                    }
                ]
                }
                >
                    <Input placeholder='Ej: La Paz, Santa Cruz, Cochabamba,...'></Input>
                </Form.Item>
                <Form.Item 
                name='status'
                label="Estado"
                >
                    <Switch checked={isChecked} onChange={setIsChecked} checkedChildren="Activo" unCheckedChildren="Inactivo"/>  
                </Form.Item>
                <Form.Item 
                name='code'
                label="Codigo"
                rules={[
                    {
                        required:true,
                        message:"Por Favor ingrese el ubicación de la sede",
                    }
                ]
                }
                >
                    <Input placeholder='Ej: LPZ-UCB1,....'></Input>
                </Form.Item>
            </Form>
        </Modal>
    )
    
}